import type { Signal } from '@angular/core';
import { InjectionToken, ViewContainerRef } from '@angular/core';

import type moment from 'moment-timezone';

import { createProviderToken } from '@core/common-legacy';
import { ReportsComponentValueDecorator } from '@core/reports-types';

// Required only because of default group difference between kiwi/rec
// TODO remove after #86c5d6zvc
const { provide: provideDecorator, inject: injectBuilderComponentDecorator } =
  createProviderToken<ReportsComponentValueDecorator>('ReportsBuilderComponentValueDecorator')();

export const provideBuilderComponentValueDecoratorFn = (
  decoratorFn: ReportsComponentValueDecorator,
) =>
  provideDecorator({
    useValue: decoratorFn,
  });

export { injectBuilderComponentDecorator };

export type ReportsEditBuilderNavigationFn = (
  componentId: string | number,
  vcRef: ViewContainerRef,
  dashboardId: number,
) => void;

const { provide: provideEditBuilderNav, inject: injectEditBuilderNav } =
  createProviderToken<ReportsEditBuilderNavigationFn>('ReportsEditBuilderNavigation')();

export const provideReportsEditBuilderNavigation = provideEditBuilderNav;
export const injectReportsEditBuilderNavigation = injectEditBuilderNav;

export const REPORTS_DASHBOARD_MIN_DATE = new InjectionToken<Signal<moment.Moment | null>>(
  'ReportsDashboardMinDateV2',
);

// HR reports can cover data migrated from before the company was created in the system,
// so there the min date must not restrict the date range selection.
const { provide: provideAllowDatesBeforeMinDate, inject: injectAllowDatesBeforeMinDate } =
  createProviderToken<boolean>('ReportsAllowDatesBeforeMinDate')(false, {
    factory: () => false,
  });

export const provideReportsAllowDatesBeforeMinDate = provideAllowDatesBeforeMinDate;
export const injectReportsAllowDatesBeforeMinDate = injectAllowDatesBeforeMinDate;
